<template>
  <div v-if="isLoaded" class="post-page">
    <div v-if="!isUnauthorizedPost">
      <div v-if="!!post && post.type === 'post'">
        <post :post="post" />
      </div>
    </div>
    <div v-else-if="isUnauthorizedPost" class="unauthorized">
      <div class="text-container">
        <p>
          {{ $t('post.postPage.unauthorized') }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import Post from '@/components/post/Post'
import { mapState } from 'vuex'

export default {
  name: 'PostPage',
  components: { Post },
  props: {
    id: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      isLoaded: false
    }
  },
  created () {
    this.loadPostData(this.id)
  },
  beforeRouteUpdate (to, from, next) {
    this.loadPostData(to.params.id)
    next()
  },
  methods: {
    loadPostData (postId) {
      this.$store.dispatch('fetchPost', postId)
        .then(() => {
          if (!this.$store.state.post.isPostFound) {
            this.$router.push({ name: 'notFound', params: { component: 'post' } })
          }
          this.isLoaded = true
        })
    }
  },
  computed: {
    post () {
      return this.$store.getters.post(this.id)
    },
    ...mapState({
      isUnauthorizedPost: state => state.post.isUnauthorizedPost
    })
  }
}
</script>

<style scoped lang="scss">
.post-page {
  display: flex;
  flex-direction: column;
  width: 638px;
  min-height: 80vh;
  max-width: 80vw;
  margin-bottom: 50px;
  @media (max-width: $small) {
    max-width: 100vw;
  }
}

.unauthorized {
  display:flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;

  width: 500px;
  margin-top: 30px;
  padding: 30px 60px;

  background-color: white;
  box-shadow: 2px 2px 8px 0 rgba(69, 69, 69, 0.20);
  border-radius: 2px;

  .text-container {
    width: 500px;
    text-align: justify;
    text-justify: inter-word;
    color: $black-color;
  }
}
</style>
